<script>
import * as categoryService from '../../../components/service/category.service';
import * as stpService from '../../../components/service/stp.service';

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        // type: Object || String,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
        last_updated: {
            type: Object,
            required: false
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
    },
    data() {
        return {
            value: this.item_value,
            options: [],
            d_check: this.selectedItem ? this.selectedItem[this.item.displayOn] : false,
            stps: [],
            pcns: [],
            none: false,
            all: this.item_value.all != undefined ? this.item_value.all : false,
            valuePcns: this.item_value.valuePcns && this.item_value.valuePcns.length ? this.item_value.valuePcns : [],
            valuePractices: this.item_value.valuePractices && this.item_value.valuePractices.length ? this.item_value.valuePractices : []
        };
    },
    computed: {
        display_none_check: {
            get: function () {
                return this.d_check;
            },
            set: function (newValue) {
                this.d_check = newValue;
            }
        }
    },
    watch: {
        none: {
            handler(val) {
                if(val) {
                    this.valuePcns = []
                    this.valuePractices = []
                }           
            },
            deep: true
        },
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {                    
                    this.display_none_check = JSON.stringify(val.value) == this.item.displayOnValue ? true : false;
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                if(this.value != val) {
                    this.value = val;
                    this.all = val.all
                    this.valuePcns = val.valuePcns
                    this.valuePractices = val.valuePractices
                }
            },
            deep: true
        },
        value(val) { 
            this.updateValue(this.item_key, val);
        },
        display_none_check(val) {
            this.item.display = this.item.displayOn && !val ? false : true
        }
    },
    methods: {
        selectedPractice(practice) {
            if(this.valuePractices.find(x => x.id == practice.id)) {
                this.valuePractices = this.valuePractices.filter(x => x.id != practice.id)
            } else {
                this.valuePractices.push(practice)
            }
            this.value = {
                all: this.all,
                valuePcns: this.valuePcns,
                valuePractices: this.valuePractices
            }
        },
        selectedPcn(pcn) {
            if(this.valuePcns.find(x => x.id == pcn.id)) {
                this.valuePcns = this.valuePcns.filter(x => x.id != pcn.id)
                this.valuePractices = []
                this.value.valuePcns = this.valuePcns
                this.value.valuePractices = []
            } else {
                this.valuePcns.push(pcn)
                this.value.valuePcns = this.valuePcns
                this.valuePractices = []
                this.value.valuePractices = []
                for(const practice of pcn.practices) {
                    this.valuePractices.push(practice)
                    this.value.valuePractices.push(practice)
                }
            }
        },
        async getStpsWithRels() {
            var filter = {
            "include": [
                {
                "relation": "ccgs",
                "scope": {
                    "include": [
                    {
                        "relation": "pcns",
                        "scope": {
                        "include": [
                            {
                            "relation": "practices"
                            }
                        ]
                        }
                    }
                    ]
                }
                }
            ]
            };
            try {

            filter = encodeURIComponent(JSON.stringify(filter));
            const data = await stpService.getWithFilter(filter)

            let stp = data.find(x => x.ccgs.length && x.ccgs[0].pcns && x.ccgs[0].pcns.length && x.ccgs[0].pcns[0].id == this.currentPcn.id)

            this.stps = data.filter(x => x.name == stp.name)
            this.pcns = this.stps.map(x => {
                return x.ccgs[0].pcns[0]
            })

            } catch (e) {
            console.log(e)
            }
        },
        async getOptions() {
            let filter = {
                "where": {
                "name": "Locations",
                "cmsId": this.$route.params.cmsId
                },
                "include": [
                {
                    "relation": "pages"
                }
                ]
            };

            filter = encodeURIComponent(JSON.stringify(filter));
            
            let data = await categoryService.getWithFilter(filter)

            let pages = data[0].pages;
            if(pages) this.options = pages;
        },
        async updateAll(val) {
            this.all = val
            if(this.all) {
                this.valuePcns = []
                this.valuePractices = []
                for(const pcn of this.pcns) {
                    this.valuePcns.push(pcn)
                    for(const practice of pcn.practices) {
                        this.valuePractices.push(practice)
                    }
                }
            } 
            else {
                this.valuePcns = []
                this.valuePractices = []
            }
            this.value = {
                all: this.all,
                valuePcns: this.valuePcns,
                valuePractices: this.valuePractices
            }
        }
    },
    async mounted() {
        this.item.display = false
        await this.getStpsWithRels()
        // await this.getOptions()
    }
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check}">
        
        <hr>

        <div class="row col-12">
            <a class="font-size-14 mb-2 mr-3 cursor-pointer"
            @click="updateAll(true)">Select All</a>  
            <a class="font-size-14 mb-2 ml-4 cursor-pointer"
            @click="updateAll(false)">Select None</a>   
        </div>

        <hr>

        <div v-for="pcn in pcns" v-bind:key="pcn.id" class="row col-12">

            <div class="form-check col-12 mb-3">
                <input class="form-check-input" type="checkbox" :id="pcn.id" :name="pcn.id"
                    :value="!!valuePcns.find(x => x.id == pcn.id)"
                    :checked="!!valuePcns.find(x => x.id == pcn.id)"
                    @input="selectedPcn(pcn)"
                >
                <label :for="pcn.id" class="form-check-label font-weight-medium">{{pcn.name}}</label>
            </div>

            <div v-for="option in pcn.practices" v-bind:key="option.id" class="form-check col-6 mb-2">
                <input class="form-check-input" type="checkbox" :id="option.id" :name="option.id"
                :value="!!valuePractices.find(x => x.id == option.id)"
                :checked="!!valuePractices.find(x => x.id == option.id)"
                @input="selectedPractice(option)"
                >
                <label :for="option.id" class="form-check-label font-weight-normal">{{option.name}}
                <i v-if="valuePractices.find(x => x.id == option.id) && valuePractices.find(x => x.id == option.id).using" class="ri-checkbox-circle-fill text-active ml-2 font-size-16 align-bottom"></i>
                </label>
            </div>

        <hr class="col-12">

        </div>

        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>



